import React from "react";

//---------------------------------------------------------------------------
// MUI Components
//---------------------------------------------------------------------------
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

//---------------------------------------------------------------------------
// Application Components
//---------------------------------------------------------------------------
import ColumnHeader from "../../components/common/ColumnHeader.jsx";

function EngineeringProjectsHeader({
  // Props
  sort,
  setSort,
}) {
  //---------------------------------------------------------------------------
  // Update the `sort` object for use by sortManager
  //---------------------------------------------------------------------------
  const handleSortSelection = (field) => setSort(field);

  return (
    <Box sx={{ p: 1 }}>
      <Grid container spacing={2} id="headersRow" sx={{ alignItems: "flex-end" }}>
        <Grid sx={{ display: { xs: "none", sm: "block" } }} size="auto">
          <Icon sx={{ m: 1 }} />
        </Grid>
        <Grid size={{ xs: 4, sm: 2.5, md: 1.5 }}>
          <ColumnHeader
            id="status"
            display="Status"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
        <Grid size="grow">
          <ColumnHeader
            id="name"
            display="Project Name"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
        <Grid size={1.5} sx={{ display: { xs: "none", md: "block" } }}>
          <ColumnHeader
            id="gl"
            display="GL"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
        <Grid size={{ xs: 1.75, md: 1.5, lg: 1.25 }} sx={{ display: { xs: "none", sm: "block" } }}>
          <ColumnHeader
            id="budget"
            display="Budget"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
        <Grid size={{ xs: 3, sm: 1.5, lg: 1.25 }}>
          <ColumnHeader
            id="cost"
            display="Cost"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
        <Grid size={1.5} sx={{ display: { xs: "none", md: "block" } }}>
          <ColumnHeader
            id="startDate"
            display="Start Date"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
        <Grid size={{ xs: 2, md: 1.5 }} sx={{ display: { xs: "none", sm: "block" } }}>
          <ColumnHeader
            id="endDate"
            display="End Date"
            sortField={sort.field}
            reverseSort={sort.reverse}
            onClick={handleSortSelection}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default EngineeringProjectsHeader;
